import React from "react";

// Zero-dependency loading indicator for the pre-Mantine bootstrap boundary.
// Must not import "@mantine/core" — it renders while that chunk is still
// being decided on/fetched (or never fetched, for an unauthenticated
// redirect), so pulling Mantine in here would defeat the whole split.
export default function PlainSpinner(): React.ReactElement {
  return <div role="status" aria-label="Loading" />;
}
